<template>
  <div id="recruitCondition">
    <div class="recruit__container">
      <div class="recruit__wrapper">
        <p class="recruit__title">홈핏 전문가에 도전해보세요</p>
        <div class="recruit__tab">
          <p class="tab__workout" :class="{on: tab === 'workout'}" @click="changeTab('workout')"></p>
          <p class="tab__meditation" :class="{on: tab === 'meditation'}" @click="changeTab('meditation')"></p>
          <p class="tab__care" :class="{on: tab === 'care'}" @click="changeTab('care')"></p>
        </div>
        <div class="workout__condition" v-if="tab === 'workout'">
          <div class="condition__swiper condition__program_swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/yoga-gray.svg" alt="yoga">
                <span>요가</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/pila-gray.svg" alt="pila">
                <span>필라테스</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/wei-gray.svg" alt="weight">
                <span>웨이트</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/mom-gray.svg" alt="mom">
                <span>산전산후 운동</span>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <p class="condition__tag">
            <span @click="clickConditionTag('yoga')">요가</span>
            <span @click="clickConditionTag('pila')">필라테스</span>
            <span @click="clickConditionTag('wei')">웨이트</span>
            <span @click="clickConditionTag('mom')">산전산후 운동</span>
          </p>
          <div class="condition__column condition__program_column pc">
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/yoga-gray.svg" alt="yoga">
              <span>요가</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/pila-gray.svg" alt="pila">
              <span>필라테스</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/wei-gray.svg" alt="weight">
              <span>웨이트</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/mom-gray.svg" alt="mom">
              <span>산전산후 운동</span>
            </p>
          </div>
          <div class="condition__column nobg">
            <div class="condition__row">
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/doc-gray.svg">
                <span>3개 이상의 자격(수료)증</span>
              </p>
            </div>
            <div class="condition__row">
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/carrot-gray.svg">
                <span>3년 이상의 실제 지도 경험</span>
              </p>
            </div>
          </div>
          <p class="condition__section_title">운동 대상</p>
          <div class="condition__swiper condition__target_swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-1.png" alt="adult">
                <span>성인</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-3.png" alt="children youth">
                <span>아동·청소년</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-2.png" alt="senior">
                <span>시니어</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-4.png" alt="prenatal postnatal">
                <span>임신부·산모</span>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <p class="condition__tag condition__target_tag">
            <span @click="clickTargetTag(0)">성인</span>
            <span @click="clickTargetTag(1)">아동·청소년</span>
            <span @click="clickTargetTag(2)">시니어</span>
            <span @click="clickTargetTag(3)">임신부·산모</span>
          </p>
          <div class="condition__column condition__target_column pc">
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-1.png" alt="adult">
              <span>성인</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-3.png" alt="children youth">
              <span>아동·청소년</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-2.png" alt="senior">
              <span>시니어</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-4.png" alt="prenatal postnatal">
              <span>임신부·산모</span>
            </p>
          </div>

        </div>
        <div class="meditation__condition" v-show="tab === 'meditation'">
          <div class="meditation__condition_inner">
            <div class="condition__common condition__left">
              <img class="lazy" data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/yogamedi-gray.svg">
              <span>요가명상</span>
            </div>
            <div>
              <div class="condition__common condition__right">
                <img class="lazy" data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/doc-gray.svg">
                <span>3개 이상의 요가 자격(이수)증 및<br>1개 이상의 명상 자격(이수)증</span>
              </div>
              <div class="condition__common condition__right">
                <img class="lazy" data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/carrot-gray.svg">
                <span>3년 이상의 요가 수업 및<br>명상 실제 수업지도 경험</span>
              </div>
            </div>
          </div>
          <p class="condition__section_title">요가명상 대상</p>
          <div class="condition__swiper condition__meditation_target_swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-1.png" alt="adult">
                <span>성인</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-3.png" alt="children youth">
                <span>아동·청소년</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-2.png" alt="senior">
                <span>시니어</span>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <p class="condition__tag condition__meditation_target_tag">
            <span @click="clickMeditationTargetTag(0)">성인</span>
            <span @click="clickMeditationTargetTag(1)">아동·청소년</span>
            <span @click="clickMeditationTargetTag(2)">시니어</span>
          </p>
          <div class="condition__column condition__target_column pc">
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-1.png" alt="adult">
              <span>성인</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-3.png" alt="children youth">
              <span>아동·청소년</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-2.png" alt="senior">
              <span>시니어</span>
            </p>
          </div>
        </div>
        <div class="care__condition" v-show="tab === 'care'">
          <div class="condition__column">
            <div class="condition__row condition__row_flex" style='display: flex;'>
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/pain-gray.svg" alt="pain">
                <span>전문 통증케어</span>
              </p>
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/care/240822/care-80-px-bg.svg" alt="care">
                <span>근골격계 케어</span>
              </p>
            </div>
          </div>
          <div class="condition__column nobg">
            <div class="condition__row">
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/doc-gray.svg" alt="pain">
                <span>3개 이상의 자격(수료)증</span>
              </p>
            </div>
            <div class="condition__row">
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/carrot-gray.svg" alt="pain">
                <span>3년 이상의 실제 지도 경험</span>
              </p>
            </div>
          </div>
          <p class="condition__section_title">전문 통증케어 대상</p>
          <div class="condition__swiper condition__care_target_swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-1.png" alt="adult">
                <span>성인</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-3.png" alt="children youth">
                <span>아동·청소년</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-2.png" alt="senior">
                <span>시니어</span>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <p class="condition__tag condition__care_target_tag">
            <span @click="clickCareTargetTag(0)">성인</span>
            <span @click="clickCareTargetTag(1)">아동·청소년</span>
            <span @click="clickCareTargetTag(2)">시니어</span>
          </p>
          <div class="condition__column condition__target_column pc">
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-1.png" alt="adult">
              <span>성인</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-3.png" alt="children youth">
              <span>아동·청소년</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/coach/recruit/260831/v2/target-2.png" alt="senior">
              <span>시니어</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.min.css';
export default {
  name: 'RecruitCondition',
  data(){
    return{
      tab: 'workout',
      swiper: null,
      targetSwiper: null,
      meditationTargetSwiper: null,
      careTargetSwiper: null,
    }
  },
  mounted(){
    this.initializeSwiper()
  },
  methods: {
    initializeSwiper() {
      this.swiper = new Swiper(".condition__program_swiper", {
        slidesPerView: "auto",
        direction: 'vertical',
        pagination: {
          el: ".condition__program_swiper .swiper-pagination",
          clickable: true,
        },
      });
      this.targetSwiper = new Swiper(".condition__target_swiper", {
        slidesPerView: "auto",
        direction: 'vertical',
        pagination: {
          el: ".condition__target_swiper .swiper-pagination",
          clickable: true,
        },
      });
      this.meditationTargetSwiper = new Swiper(".condition__meditation_target_swiper", {
        slidesPerView: "auto",
        direction: 'vertical',
        pagination: {
          el: ".condition__meditation_target_swiper .swiper-pagination",
          clickable: true,
        },
      });
      this.careTargetSwiper = new Swiper(".condition__care_target_swiper", {
        slidesPerView: "auto",
        direction: 'vertical',
        pagination: {
          el: ".condition__care_target_swiper .swiper-pagination",
          clickable: true,
        },
      });
    },
    changeTab(x){
      this.tab = x
      setTimeout(()=> { this.initializeSwiper()},300)
    },
    clickConditionTag(x){
      switch(x){
        case 'yoga': if(this.swiper) this.swiper.slideTo(0, 500); break;
        case 'pila': if(this.swiper) this.swiper.slideTo(1, 500); break;
        case 'wei': if(this.swiper) this.swiper.slideTo(2, 500); break;
        case 'mom': if(this.swiper) this.swiper.slideTo(3, 500); break;
        default: return;
      }
    },
    clickTargetTag(index){
      if(this.targetSwiper) this.targetSwiper.slideTo(index, 500)
    },
    clickMeditationTargetTag(index){
      if(this.meditationTargetSwiper) this.meditationTargetSwiper.slideTo(index, 500)
    },
    clickCareTargetTag(index){
      if(this.careTargetSwiper) this.careTargetSwiper.slideTo(index, 500)
    },
    clickConditionTagForCare(x){
      switch(x){
        case 'pain': this.swiper.slideTo(0, 500); break;
        case 'care': this.swiper.slideTo(2, 500); break;
        default: return;
      }
    }
  }
}
</script>
<style scoped  lang="scss">
#recruitCondition {
  .condition__program_column {
    background: transparent;
    padding: 0;
    align-items: stretch;
    .condition__item {
      flex: 1;
      margin-left: 0;
      padding: 38px 0;
      background: #fafafa;
      &:first-child { border-radius: 12px 0 0 12px; }
      &:nth-child(3) { border-radius: 0 12px 12px 0; }
      &:last-child { margin-left: 11px; border-radius: 12px; }
    }
  }
  .condition__section_title {
    width: 100%;
    margin: 40px 0 12px;
    color: #9191a0;
    font-size: 16px;
    line-height: 1.3;
  }
  .condition__target_column {
    margin-top: 0;
  }
  .meditation__condition {
    flex-direction: column;
    align-items: center;
    .meditation__condition_inner {
      display: flex;
    }
    .condition__target_column {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 12px;
      background-color: #fafafa;
      padding: 38px 0;
      .condition__item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 80px;
          height: 80px;
        }
        span {
          font-size: 20px;
          margin-top: 24px;
        }
        & + .condition__item {
          margin-left: 115px;
        }
      }
    }
    .condition__swiper,
    .condition__tag {
      display: none;
    }
  }
  .care__condition {
    .condition__row_flex {
      display: flex;
      .condition__item:nth-child(2) {
        margin-left: 200px;
      }
    }
  }
}
@media all and (max-width: 768px) {
  #recruitCondition {
    .condition__section_title {
      margin-top: 32px;
      margin-bottom: 12px;
    }
    .meditation__condition {
      .meditation__condition_inner {
        width: 100%;
        flex-direction: column;
      }
      .condition__target_column.pc {
        display: none;
      }
      .condition__swiper {
        width: 100%;
        height: 160px;
        display: block;
        overflow: hidden;
        position: relative;
        .swiper-slide {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 160px;
          background-color: #fafafa;
          border-radius: 12px;
          img {
            width: 60px;
            height: 60px;
            margin-bottom: 12px;
          }
          span {
            font-size: 16px;
          }
        }
      }
      .condition__tag {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 12px auto;
        width: 100%;
        span {
          flex: 1;
          display: inline-flex;
          max-width: 93px;
          height: 22px;
          justify-content: center;
          align-items: center;
          background-color: #e1e1eb;
          border-radius: 12px;
          font-size: 14px;
          & + span {
            margin-left: 4px;
          }
        }
      }
    }
    .care__condition {
      .condition__row_flex {
        .condition__item:nth-child(2) {
          margin-left: 100px;
        }
      }
    }
  }
}
</style>
